<template>
  <div class="article-list">
    <div class="one-article" v-for="(item, index) in newarticlelist" :key="index" @click="goToArticleDetail(item)">
      <div class="article-img">
        <img :src="api.concat(item.coverImg)" style="width:100%;height:100%" alt="" />
      </div>
      <div class="article-container">

        <div class="article-title">
          <span>{{ item.title }}
          </span>
        </div>

        <div class="article-intro">
          <span>{{ item.info }}</span>
        </div>

        <div class="article-one-info">
          <div class="intro-first">
            <span class="publish-tihme">{{ formatDate(Date.parse(item.time)) }}</span>
          </div>

          <div class="intro-second">
            <div class="clo-info">
              <i class="hot-icon"></i>
              <span>{{ item.readNum }}热度</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p v-if="newarticlelist.length<=0">暂无数据</p>
  </div>
</template>

<script>
import { changReadNum } from '@/services/'
import api from '@/services/config.js'
import { formatDate } from "@/js/common";
export default {
  props: {
    newarticlelist: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      api, formatDate
    }
  },
  methods: {
    //打开文章详情
    async goToArticleDetail(item) {
      let id = item.id;
      changReadNum({ arctitleId: id }).then(res => {
        console.log(res);
      })
      this.$router.push({
        name: 'ArticleDetail',
        params: item
      })

    }
  },
};
</script>

<style scoped>
.imged {
  border-radius: 50%;
  height: 40px;
  width: 40px;
  cursor: pointer;
}

.article-img:hover,
.article-title>span:hover,
.article-intro>span:hover,
.head-icon:hover,
.author-name:hover {
  cursor: pointer;
}

.article-list {
  padding: 0 22px;
  text-align: left;
  background: white;
}

.article-list .one-article {
  background: white;
  height: 150px;
  padding: 20px 0;
}

.article-list>.one-article {
  overflow: hidden;
  border-bottom: 1px dashed rgba(111, 111, 111, 1);
}

.article-container,
.article-img {
  display: inline-block;
  height: 100%;
  position: relative;
}

.article-img {
  width: 33%;
}

.article-container {
  width: 65%;
  vertical-align: top;
  margin-left: 2%;
}

.article-title>span {
  color: #5e6b73;
  font-size: 18px;
  line-height: 24px;
}

.article-intro {
  margin-top: 30px;
  color: #5e6b73;
  font-size: 14px;
  font-weight: lighter;
}

.article-one-info {
  width: 96%;
}

.article-other-info {
  position: absolute;
  bottom: 0px;
  width: 96%;
}

.intro-first {
  display: inline-block;
  position: absolute;
  left: 0px;
  bottom: 0;
}

.intro-first>*,
.intro-second>* {
  vertical-align: middle;
}

.head-icon {
  height: 22px;
  width: 22px;
  display: inline-block;
}

.author-name,
.collect-num,
.comment-num,
.publish-tihme {
  color: #a5a7b3;
}

.author-name {
  font-size: 12px;
  margin-left: 5px;
  height: 20px;
  line-height: 20px;
  display: inline-block;
}

.publish-tihme {
  line-height: 20px;
  height: 20px;
  display: inline-block;
}

.publish-tihme,
.comment-icon {
  margin-left: 10px;
}

.intro-second {
  display: inline-block;
  position: absolute;
  right: 0px;
  bottom: 0;
}

.intro-second .keyword {
  border: 1px solid rgba(181, 181, 181, 1);
  border-radius: 13px;
  text-align: center;
  font-size: 12px;
  padding: 3px;
  display: inline-block;
  width: 60px;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.intro-second .keyword:not(:first-of-type) {
  margin-left: 5px;
}

.keyword-icon {
  height: 18px;
  width: 18px;
  background-image: url('~@/assets/icon/icon.png');
  background-position-x: 518px;
  background-position-y: -38px;
  display: inline-block;
}

.collect-icon {
  height: 18px;
  width: 18px;
  background-image: url("~@/assets/icon/sc.png");
  display: inline-block;
  background-size: 18px 18px;
  background-position-x: 1px;
  background-position-y: -0.2px;
  margin-right: 4px;
}

.article-other-info .clo-info {
  width: 20%;
  height: 100%;
  display: inline-block;
  vertical-align: middle;
}

.article-other-info .clo-info * {
  vertical-align: middle;
}

.article-other-info .clo-info span {
  font-size: 14px;
}

.article-other-info span,
.article-one-info span {
  color: #585858;
}

.article-one-info .intro-second span:hover {
  cursor: pointer;
  background-color: #fd6e05;
  color: white;
  border-color: white;
}

/* 图标icon */
.hot-icon {
  height: 18px;
  width: 18px;
  background-image: url("~@/assets/icon/rd(1).png");
  display: inline-block;
  background-size: 18px 18px;
  background-position-x: 1px;
  background-position-y: -0.2px;
  margin-right: 2px;
}

.attention-icon {
  height: 18px;
  width: 18px;
  background-image: url('~@/assets/icon/icon.png');
  background-position-x: 664px;
  background-position-y: -45px;
  display: inline-block;
}

.praise-icon {
  height: 18px;
  width: 18px;
  background-image: url("~@/assets/icon/dz.png");
  display: inline-block;
  background-size: 18px 18px;
  background-position-x: 1px;
  background-position-y: -0.2px;
  margin-right: 4px;
}

.comment-icon {
  height: 18px;
  width: 18px;
  background-image: url("~@/assets/icon/pl.png");
  background-size: 18px 18px;
  background-position-x: 0.8px;
  background-position-y: 0.6px;
  display: inline-block;
  margin-right: 4px;
}
</style>
